import React, { useState } from 'react';
import { Link } from 'gatsby';

import Icon from '~/components/modules/icon';

import HealthyDelawareIcon from '~/images/inline/healthy-delaware-icon.svg';
import HealthyDelaware from '~/images/inline/healthy-delaware.svg';

import routes from '~/data/routes';

// Recrusively search the node and its children for a node at the level that is or contains a child that matches the path
const getLevelNav = (parent, route, path, level) => {
	// This node is the current path or the current path is one level down
	// TODO: This could recursively look DOWN the tree for the path intead of just one level down
	if (route.level === level && (route.path === path || route.children?.some(child => child.path === path))) {
		return route;
	} else if (route.children) {
		for (let i = 0; i < route.children.length; i++) {
			const child = route.children[i];
			const result = getLevelNav(route, child, path, level);
			if (result) {
				return result;
			}
		}
	}
	return null;
};

const Navbar = ({
	location,
	hasNavigation = true,
	sectionTitle,
	sectionUrl,
	showToolkitsLabel = true
}) => {
	const [isExpanded, toggleExpansion] = useState(false);
	const level3Nav = getLevelNav(null, routes, location.pathname, 3);

	return (
		<div className="container flex flex-wrap justify-between items-center mx-auto px-4 py-2">
			<div className="flex items-center basis-1/4 lg:basis-full lg:mb-4">
				<p className="mr-2 font-bold text-xs text-gray-450 hidden lg:block">Back to</p>
				<a
					href="https://www.healthydelaware.org/community-partners/toolkits"
					className="inline-flex items-center gap-2"
				>
					<span className="sr-only">HealthyDelaware.org</span>
					<HealthyDelawareIcon
						className="h-6 lg:h-4 text-emerald-650"
						aria-hidden="true"
						role="img"
					/>
					<HealthyDelaware
						className="h-2.5 text-gray-450 hidden lg:block"
						aria-hidden="true"
						role="img"
					/>
				</a>
			</div>

			{hasNavigation &&
				<>
					<div className="grow basis-0">
						<Link
							to={sectionUrl}
							className="relative uppercase text-center lg:text-left text-indigo-950 transition-colors hover:text-indigo-800 focus:text-indigo-800 no-underline"
						>
							<h1
								className="font-black text-lg md:text-2xl"
							>
								<Icon
									iconImage="mdi:home"
									sizeClasses="w-5 h-5 md:w-[1.8rem] md:h-[1.8rem]"
									className="inline-block align-text-bottom"
								/>
								{sectionTitle}
							</h1>
						</Link>
					</div>

					<div className="block lg:hidden basis-1/4 text-right">
						<button
							className={`
								px-3.5 py-2.5 transition-colors hover:bg-gray-100 focus:bg-gray-100
								${isExpanded ? 'text-emerald-650' : 'text-gray-700'}
							`}
							onClick={() => toggleExpansion(!isExpanded)}
						>
							<svg
								viewBox="0 0 20 20"
								xmlns="http://www.w3.org/2000/svg"
								className={`
									block w-5 h-5 fill-current transition-transform
									${isExpanded ? `transform-gpu rotate-180` : ``}
								`}
							>
								<title>Menu</title>
								<rect
									y="3"
									width="20"
									height="2"
									className={`
										transition
										${isExpanded ? `transform-gpu rotate-45 translate-y-[0] translate-x-[6px]` : ``}
									`}
								/>
								<rect
									y="9"
									width="20"
									height="2"
									className={`
										transition
										${isExpanded ? `opacity-0` : ``}
									`}
								/>
								<rect
									y="15"
									width="20"
									height="2"
									className={`
										transition
										${isExpanded ? `transform-gpu -rotate-45 translate-y-[6px] translate-x-[-8px]` : ``}
									`}
								/>
							</svg>
						</button>
					</div>

					<div
						className={`
							lg:flex flex-wrap items-center justify-between basis-full lg:basis-auto pt-4 lg:pt-0 text-xs
							${isExpanded ? 'block' : 'hidden'}
						`}
					>
						{showToolkitsLabel &&
							<p className="mb-2 lg:mb-0 mr-2 font-bold text-center lg:text-left text-gray-450">View Toolkits:</p>
						}
						<nav
							className="lg:flex items-center w-full md:w-auto pt-2 md:pt-0"
						>
							{level3Nav?.children?.map(route => (
								<Link
									className="block uppercase text-center font-black px-3.5 py-2 lg:py-1.5 text-gray-700 no-underline transition-colors hover:text-white hover:bg-emerald-650 focus:text-white focus:bg-emerald-650"
									key={route.title}
									to={route.path}
									activeClassName="bg-emerald-650 !text-white"
								>
									{route.title}
								</Link>
							))}
						</nav>
					</div>
				</>
			}
		</div>
	);
};

export default Navbar;
